/**
 * @generated SignedSource<<c129b49afba41469e586008ad75cb7e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventHostInvitationBanner_query$data = {
  readonly viewer: {
    readonly rowId: string;
  } | null | undefined;
  readonly " $fragmentType": "EventHostInvitationBanner_query";
};
export type EventHostInvitationBanner_query$key = {
  readonly " $data"?: EventHostInvitationBanner_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventHostInvitationBanner_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventHostInvitationBanner_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e4db250ffc7a0987a9b1f0759651054e";

export default node;
